import React from 'react';
import { HeaderLower, HeaderUpper } from './style';

const Header = () => (
  <>
    <HeaderUpper>
      <p className="first">BIRO PENDIDIKAN (BIRPEND) ONLINE</p>
      <p className="second">LAYANAN KULIAH UMUM DAN SEMINAR ILMIAH</p>
    </HeaderUpper>
    <HeaderLower />
  </>
);

export default Header;
